export class NewNotification {
    data: string;
    url: string;
    texto: string;
    lida: string;
    tipo: string;
}